export const CODE_EXPIRED = "auth/expired-action-code";
export const CODE_INVALID = "auth/invalid-action-code";
